function stringSort(arr, config) {
  var locale = (config && config.locale) || 'en-US'
  return arr.sort(new Intl.Collator(locale).compare)
}

module.exports = stringSort
